import {
  PaymentRecurrenceInterval as DomainRecurrenceInterval,
} from 'application-types';
import {
  RecurrenceInterval,
} from 'graphql-query-contracts';

/**
 * Convert domain RecurrenceInterval to GraphQL RecurrenceInterval enum.
 * Maps from domain enum (RECURRENCE_INTERVAL_MONTHLY) to GraphQL enum (RecurrenceIntervalMonthly).
 */
export function convertRecurrenceInterval(
  domainInterval: DomainRecurrenceInterval
): RecurrenceInterval {
  switch (domainInterval) {
    case DomainRecurrenceInterval.RECURRENCE_INTERVAL_DAILY:
      return RecurrenceInterval.RecurrenceIntervalDaily;
    case DomainRecurrenceInterval.RECURRENCE_INTERVAL_WEEKLY:
      return RecurrenceInterval.RecurrenceIntervalWeekly;
    case DomainRecurrenceInterval.RECURRENCE_INTERVAL_MONTHLY:
      return RecurrenceInterval.RecurrenceIntervalMonthly;
    case DomainRecurrenceInterval.RECURRENCE_INTERVAL_YEARLY:
      return RecurrenceInterval.RecurrenceIntervalYearly;
    case DomainRecurrenceInterval.RECURRENCE_INTERVAL_UNKNOWN:
    default:
      return RecurrenceInterval.RecurrenceIntervalUnknown;
  }
}

